export default "__VITE_ASSET__C04iVmgz__"